import {Component} from "react";
import myEmitter from "./my-events";
import demo from "../imgs/demo.jpg";
import {Radio} from "antd";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as setAnswer from "../actions/evaluation";
import React from "react";
import {requestPost} from "../utils/Util";
const RadioGroup = Radio.Group;

class Reading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            textArray: {},
            lineY: {}
        }

        this.answer = {
            index: '',
            value:''
        };
        const {answer,currentEvaluation} = props;
        const {answers} = answer;
        if(answers[currentEvaluation.page]){
            this.state.value = answers[currentEvaluation.page].value;
        }
    }

    keyLight(id){
        // var m = document.getElementsByTagName('a');
        // for(var i = 0; i<m.length; i++){
        //     if(m[i].getAttribute('qid') === id){
        //         // console.log(m[i])
        //         // var s = m[i].getClientRects()[0].top - 300;
        //         // document.getElementsByClassName('content')[0].scrollTo(0,s)
        //         m[i].setAttribute('fill','#ffc107')
        //     }
        // }
        var textArray = this.state.textArray;
        var lineY = this.state.lineY;
        var textLines = Object.keys(textArray);
        var titleContent = document.getElementsByClassName("options")[0].getElementsByTagName("p")[0].textContent;
        var result = /lines \d+-\d+/.exec(titleContent);
        var i,j, lines, begin, end, beginIndex, endIndex;
        var hasScroll = false;
        if(result && result.length > 0){
            for(i=0; i<result.length; i++){
                lines = result[i].split(" ")[1].split("-");
                begin = parseInt(lines[0]);
                end = parseInt(lines[1]);
                // beginIndex = parseInt(begin/5);
                // endIndex = parseInt(end/5);
                // lineY[beginIndex]
                for(j=begin; j<=end; j++){
                    textArray[textLines[j-1]].setAttribute('filter','url(#solidBgColor)');
                    if(textLines[j-1] === textLines[j]){ // 同行key被冲掉了
                        end = end+1;
                    }
                    if(!hasScroll){
                        var scrollTransform = textArray[textLines[j-1]].getAttribute("transform");
                        if(scrollTransform){
                            var scrollY = parseInt(scrollTransform.split(" ")[1].split(")")[0]);
                            document.getElementsByClassName('content')[0].scrollTo(0, parseInt(scrollY));
                            hasScroll = true;
                        }
                    }

                }
            }

        }
        result = /line \d+/.exec(titleContent);
        if(result && result.length > 0){
            for(i=0; i<result.length; i++){
                begin = result[i].split(" ")[1];
                textArray[textLines[begin-1]].setAttribute('filter','url(#solidBgColor)');
                if(!hasScroll){
                    var scrollTransform = textArray[textLines[begin-1]].getAttribute("transform");
                    if(scrollTransform){
                        var scrollY = parseInt(scrollTransform.split(" ")[1].split(")")[0]);
                        if(begin == textLines.length){
                            scrollY += 200;
                        }
                        document.getElementsByClassName('content')[0].scrollTo(0, parseInt(scrollY));
                        hasScroll = true;
                    }

                }
            }

        }

    }


    _handlerNextQuestion = (action)=>{
        this._doSetAnswer(action);
    }

    async _setAnswer(page,A){
        const {match,answercurrentEvaluation,answer} = this.props;
        var params = {
            url: window.location.href.split('question/')[1].replace(/\//g,'_'),
            info: JSON.stringify({...answer.answers,[page]:A})
        }

        const answerSet = await requestPost(`/questionnaires/test_questions_save/`,'POST', params);
        console.log(params,answerSet);
    }

    _doSetAnswer(action) {
        const {actions,currentEvaluation} = this.props;
        this.answer.index = currentEvaluation.page;
        this.answer.value = this.state.value;
        console.log(action,actions)
        this._setAnswer(currentEvaluation.page,{index:this.answer.index,value:this.answer.value});
        actions.setAnswer(currentEvaluation.page, this.answer, this.answer);
    }

    componentWillUnmount() {
        myEmitter.off('nextQuestion', this._handlerNextQuestion);
        myEmitter.off('prevQuestion', this._handlerNextQuestion);
    }

    componentDidMount() {
        myEmitter.on('nextQuestion', this._handlerNextQuestion);
        myEmitter.on('prevQuestion', this._handlerNextQuestion);
        const {answer,evaluation,currentEvaluation} = this.props;
        var h = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.units[currentEvaluation.page] : '';
        if(!h) return;
        //
        var bgFilterDef = document.createElementNS('http://www.w3.org/2000/svg','defs')
        bgFilterDef.innerHTML = ""+
            '<filter x="0" y="0" width="1" height="1" id="solidBgColor">'+
            '<feFlood flood-color="#ffff7b"></feFlood>'+
            '<feComposite in="SourceGraphic"></feComposite>'+
            '</filter>'+
            '';
        var svgNode = document.getElementsByClassName("content_reading")[0].getElementsByTagName("svg")[0];

        svgNode.insertBefore(bgFilterDef, svgNode.getElementsByTagName("g")[0]);
        var textNodes = svgNode.getElementsByTagName("text");
        var transform, yValue, textAnchor;
        var textArray = this.state.textArray;
        var lineY = this.state.lineY;
        var minLineY = 0;
        var lineTransform = [];
        for(var i=0; i< textNodes.length; i++){
            transform = textNodes[i].getAttribute("transform");
            textAnchor = textNodes[i].getAttribute("text-anchor");
            if(transform){
                yValue = parseInt(transform.split(" ")[1].split(")")[0]);
                if(textAnchor === "right"){
                    lineY[parseInt(textNodes[i].textContent)] = yValue;
                    if(parseInt(textNodes[i].textContent) === 5){
                        minLineY = yValue - 21*5;
                    }
                    lineTransform.push(transform);
                }
            }

        }
        for(var i=0; i< textNodes.length; i++){
            transform = textNodes[i].getAttribute("transform");
            textAnchor = textNodes[i].getAttribute("text-anchor");
            if(transform && lineTransform.indexOf(transform) === -1){
                yValue = parseInt(transform.split(" ")[1].split(")")[0]);
                if(yValue > minLineY){
                    textArray[yValue] = textNodes[i];
                }

            }

        }
        this.setState({
            textArray: textArray,
            lineY:lineY
        });

        //
        this.keyLight(h.questions.uuid);
    }


    onChange = (e) => {
        const {actions,currentEvaluation,evaluation} = this.props;
        console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        },()=>{
            if(currentEvaluation.page === evaluation.datas.content_object_content.units.length-1){
                this._doSetAnswer('');
            }
        });
    }
    render() {
        const radioGroupStyle = {
            display: 'block'
        };
        const radioStyle = {
            display: 'block',
            minHeight: '30px',
            paddingBottom: '10px',
            whiteSpace: 'normal',
            wordBreak: 'break-all'
        };
        const {answer,evaluation,currentEvaluation} = this.props;
        var h = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.units[currentEvaluation.page] : '';
        return (
            <div className='questionItem'>
                <div className='content content_reading'>
                    <div dangerouslySetInnerHTML={{__html: h.passage}}/>
                </div>
                <div className='options'>
                    <p  dangerouslySetInnerHTML={{__html: !h ? '' : h.questions.description}} />
                    <div className='options_group'>
                        <RadioGroup style={radioGroupStyle} onChange={this.onChange} value={this.state.value}>
                            {
                                h.questions.options.map((item,index)=>{
                                    return <div className="optionsDiv">
                                        <div className="options_ratio">
                                            <Radio style={radioStyle} value={item.id}></Radio>
                                        </div>
                                        <div className="options_content">
                                            <span style={{marginRight:3}}>{item.letter}.</span>
                                            <span className='optionContent' dangerouslySetInnerHTML={{__html: item.value}}/>
                                        </div>

                                    </div>
                                    // return <Radio style={radioStyle} value={item.id}><span style={{marginRight:10}}>{item.letter} </span>
                                    //     <span className='optionContent' dangerouslySetInnerHTML={{__html: item.value}}/></Radio>
                                })
                            }
                        </RadioGroup>
                    </div>
                </div>
            </div>
        );
    }
}
Reading = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer,
}), (dispatch) => ({
    actions: bindActionCreators(setAnswer, dispatch),
}))( Reading);
export {Reading};
